import {appendPaginationQueryParamsToUrl, get} from '../utils'
import { includeQuery } from './utils'

export default host => (channelId, options, include = includeQuery) =>
  get(appendPaginationQueryParamsToUrl(`${host}/channels/${channelId}/products?${include}`, {...options, alreadyHasQueryParams: true}))
    .then(response => response.json())
